module.exports = __webpack_public_path__ + "img/latvia.bb32fbe2.svg";